<template>
  <div
    class="event_item pr draggable_item"
    :class="[{startShow:warningText1,endShow:warningText2,IsScteStart: IsScteStart},`a${data.id}`]"
    :style="{
      background: data.scteId > 0 ? '#000' : data.colorBack,
      top: `${data.LocationTop}px`,
      height: `${getHeight()}px`
    }"
    draggable="true"
    :data-id="data.id"
    @click="openEventFormBox">
    <div
      class="event_detail"
      :class="{daylightSavingTime: data.daylightSavingTime == 2}"
      :data-event="JSON.stringify(data)"
      :style="{
        height: `${getHeight()}px`,
        border: mainSource ? 'solid 3px #FFFFFF' : 'solid 0px transparent'
      }" >
      <div
        v-if="getHeight() >= 12"
        :style="{ fontSize: `${getHeight() <= 18 ? '12px' : ''}` }"
        >
        <div
          class="start_time"
          :style="{ top: getHeight() > 20 ? '12px' : '' }"
          :title="transitionHourly(new Date(data.startTime))">
          {{ transitionHourly(new Date(data.startTime)) }}
        </div>
        <!-- pgm start end -->
        <span v-if="StartingUpLoading&&data.takeNextFlag"><i class="el-icon-loading"></i></span>
        <el-tooltip class="item" effect="dark"  placement="bottom-start" popper-class='scteWarning' v-if="data.pgmStartScte||data.pgmEndScte">
          <div slot="content">{{pgmStartTipsText(data)}}<br v-if="data.pgmStartScte"/>{{pgmEndTipsText(data)}}</div>
          <span class="warning" v-if="data.pgmStartScte||data.pgmEndScte"><i class="iconfont icon-warning2"  :class="data.liveStatus!=0&&data.liveStatus!=1?'grayWarning':''"></i></span>
        </el-tooltip>
        <!-- 是否有source -->
        <el-tooltip class="item" effect="dark"  placement="bottom-start" v-if="sourceBlank" >
          <div slot="content">{{IfSourceBlank}}</div>
          <span class="warning" ><i class="iconfont icon-a-eventwarning" ></i></span>
        </el-tooltip>
        <span
          class="item_info ellipsis"
          :title="data.title">{{
            data.title
          }}</span>
        <span
          class="item_info ellipsis"
          :title="`${data.multipleModelType?'F/O':''} ${data.multipleModelType&&data.eventModelType?'&':''} ${mode[data.eventModelType]}`"
          v-if="data.multipleModelType||data.eventModelType"
          >{{data.multipleModelType?'F/O':''}} {{data.multipleModelType&&data.eventModelType?'&':''}} {{mode[data.eventModelType]}}</span>
        <span
          class="item_info ellipsis"
          v-else
          :title="data.startTime | GETDURATION(data.endTime)">TRT: {{ data.startTime | GETDURATION(data.endTime) }}</span>
        <!--                    <span class='item_info ellipsis' :title='data.clipId'>Clip ID: {{ data.clipId }}</span>-->
        <span
          class="item_info ellipsis"
          :title="data.houseId">{{ $t('lang.HouseId') }} {{ data.houseId }}</span>
        <span class="item_info ellipsis">
          <!-- <i class="f_right el-icon-document-copy pointer"></i> -->
            <span class="audioLevelDb" v-if="data.audioLevel&&data.audioLevel!='0'" ><i class="iconfont icon-volume-up"></i> {{((0>data.audioLevel*1 )||(data.audioLevel*1==0))?' ':'+'}}{{data.audioLevel}}dB</span>
            <span
            class="f_left"
            style="margin-right: 30px" v-else>{{ $t('lang.CCText') }}</span>
        </span>
        <div
          class="IconWrap"
          @click="ClickIconCompile"
          style="pointer-events: auto;">
          <!-- logo图标 -->
          <p
            v-if="data.logoFlag"
            :style="{ background: data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA':'#AE68F4' }">
            <i
              class="iconfont icon-LG"></i>
          </p>
          <!-- crawl图标 -->
          <p
            v-if="data.crawlFlag"
            :style="{ background: data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA':'#70BDE8' }">
            <i
              class="iconfont icon-CR"></i>
          </p>
          <!-- D图标 -->
          <p
            v-if="data.copy == 'true'"
            :style="{ background: data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA':'#67aa25' }">
            <i
              class="iconfont icon-duplicate1"></i>
          </p>
          <!-- cc图标 -->
          <p :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#aaaaaa' }">
            <i
              class="iconfont icon-cc"></i>
          </p>
          <!-- R图标 -->
          <p
            v-if="data.record"
            :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#ec5050' }">
            <i
              class="iconfont icon-secondaryrecord"></i>
          </p>
          <p
            v-else
            :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#ec5050' }">
            <i
              class="iconfont icon-secondaryrecordoff"></i>
          </p>
          <!-- s图标 -->
          <p :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#f2f2f2' }">
            <i
              class="iconfont icon-SCTEoff"></i>
          </p>
        </div>
      </div>
    </div>
    <!-- 时间较短事件显示 -->
    <div
      class="active_box"
      v-if="getHeight() < 12"
      @click="openEventFormBox">
      <div
        :style="{
          background: data.colorBack,
          border: `1px solid ${getBorderColor(data.colorBack)}`,
        }">
        <div
          class="start_time"
          :title="data.startTime | DATE('hh:mm:ss')">
          {{ data.startTime | DATE("hh:mm:ss") }}
        </div>
        <el-tooltip class="item" effect="dark"  placement="bottom-start" popper-class='scteWarning' v-if="data.pgmStartScte||data.pgmEndScte">
          <div slot="content">{{pgmStartTipsText(data)}}<br v-if="data.pgmStartScte"/>{{pgmEndTipsText(data)}}</div>
          <span class="warning" v-if="data.pgmStartScte||data.pgmEndScte"><i class="iconfont icon-warning2"  :class="data.liveStatus!=0&&data.liveStatus!=1?'grayWarning':''"></i></span>
        </el-tooltip>
        <span
          class="item_info ellipsis"
          :title="data.title">{{
            data.title
          }}</span>
        <span
          class="item_info ellipsis"
          v-if="data.multipleModelType||data.eventModelType"
          >{{data.multipleModelType?'F/O':''}} {{data.multipleModelType&&data.eventModelType?'&':''}} {{mode[data.eventModelType]}}</span>
        <span
          class="item_info ellipsis"
          v-else
          :title="data.startTime | GETDURATION(data.endTime)">TRT: {{ data.startTime | GETDURATION(data.endTime) }}</span>
        <!--                    <span class='item_info ellipsis' :title='data.clipId'>Clip ID: {{ data.clipId }}</span>-->
        <span
          class="item_info ellipsis"
          :title="data.houseId">{{ $t('lang.HouseId') }} {{ data.houseId }}</span>
        <span class="item_info ellipsis">
          <!-- <i class="f_right el-icon-document-copy pointer"></i> -->
          <span
            class="f_left"
            style="margin-right: 30px">{{ $t('lang.CCText') }}</span>
        </span>
        <i
          class="el-icon-caret-bottom"
          :style="{ color: data.colorBack }"></i>
        <div
          class="IconWrap"
          @click.stop="ClickIconCompile">
          <!-- logo图标 -->
          <p
            v-if="data.logoFlag"
            :style="{ background: data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA':'#AE68F4' }">
            <i
              class="iconfont icon-LG"></i>
          </p>
          <!-- crawl图标 -->
          <p
            v-if="data.crawlFlag"
            :style="{ background: data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA':'#70BDE8' }">
            <i
              class="iconfont icon-CR"></i>
          </p>
          <!-- D图标 -->
          <p
            v-if="data.copy == 'true'"
            :style="{ background: data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA':'#67aa25' }">
            <i
              class="iconfont icon-duplicate1"></i>
          </p>
          <!-- cc图标 -->
          <p :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#aaaaaa' }">
            <i
              class="iconfont icon-cc"></i>
          </p>
          <!-- R图标 -->
          <p
            v-if="data.record"
            :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#ec5050' }">
            <i
              class="iconfont icon-secondaryrecord"></i>
          </p>
          <p
            v-else
            :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#ec5050' }">
            <i
              class="iconfont icon-secondaryrecordoff"></i>
          </p>
          <!-- s图标 -->
          <p :style="{ background:data.liveStatus==2||data.liveStatus==4 ?'#AAAAAA': '#f2f2f2' }">
            <i
              class="iconfont icon-SCTEoff"></i>
          </p>
        </div>
      </div>
    </div>
    <!-- scte等子事件显示盒子 -->
    <div
      class="ScteListWrap"
      v-if="data.eventSegments.length>0">
      <div
        v-for="(item, index) in data.eventSegments"
        :key="index">
        <div
          class="ScteWrap"
          v-if="item.segmentId != 1 && item.segmentId != 9 && item.segmentId != 13"
          :style="computedStyle(item, data)" >
        </div>
        <div
          class="SerialNumber "
          v-if="item.segmentId == 1"
          :style="computedStyle(item, data)" >
          {{item.SerialNumber}}
        </div>
      </div>
    </div>
    <!-- 检测活动时间线 -->
    <div class="DetectionActiveLine" v-if="data.pgmEndScte && ScteData.enablePgmEndDetection && !ActiveGreaterNow" :style="{top: getActiveHeight() + 'px'}">
      <div class="dummyLineLeft"></div>
      <div class="ActiveHint">
        <el-tooltip class="item" effect="dark"  placement="bottom-start" popper-class='scteWarning' >
          <div slot="content">{{$t('lang.sctePgmEndNote2')}}</div>
          <span class="warning">
            <i class="iconfont icon-warning2" :class="data.liveStatus!=0&&data.liveStatus!=1?'grayWarning':''"></i>
          </span>
        </el-tooltip>
        <span class="DetectionActive">{{$t('lang.DetectionActive')}} {{ActiveTime()}}</span>
      </div>
      <div class="dummyLineRight"></div>
    </div>
  </div>
  <!-- </el-popover> -->
</template>

<script>
import Outil from '@/assets/js/utils.js'
import { EventBorderColor } from '@/assets/js/common/ParamConfig.js'
export default {
  components: {
  },
  props: {
    // 事件信息
    data: {
      type: Object,
      default: () => { }
    },
    // 下一个事件的信息
    nextEventMessage: {
      type: Object,
      default: () => { }
    },
    // scte激活相关信息
    ScteData: {
      type: Object,
      default: () => ({})
    },
    StartingUpLoading: {
      type: Boolean,
      default: () => (false)
    }
  },
  data () {
    return {
      // 事件边框颜色
      colors: EventBorderColor,
      // 警告文字以及显示
      warningShow: false,
      warningText1: '',
      warningText2: '',
      // 是否开始是scte
      IsScteStart: false,
      mode: {
        0: '',
        1: 'HLD/MAN',
        2: 'EXT'
      },
      // 夏令时时间
      DstTime: {
        isDst: false
      },
      // SOURCE空白
      sourceBlank: 1,
      // 主源是否为空
      mainSource: false
    }
  },
  mounted () {
  },
  computed: {
    // 激活时间是否大于事件时间
    ActiveGreaterNow () {
      if (this.ScteData.enablePgmEndDetection) {
        let priorToEndTime = Number(this.ScteData.priorToEndTime)
        priorToEndTime = priorToEndTime * 60 * 1000
        const duration = this.data.endTime - this.data.startTime
        return priorToEndTime > duration
      }
      return false
    },
    // 判断source是否为空
    IfSourceBlank () {
      let Point = ''
      if (this.sourceBlank == 1) {
        Point = this.$t('lang.gapPoint')
      } else if (this.sourceBlank == 2) {
        Point = this.$t('lang.sourceBlank')
      } else if (this.sourceBlank == 3) {
        Point = this.$t('lang.gapSourceBlank')
      }
      return Point
    }
  },
  watch: {
    // 下一个事件是否是sctePgmStar Or End
    nextEventMessage: {
      handler (val) {
        if (val.id == this.data.id) {
          if (val.pgmStartScte == 1 && val.pgmEndScte == 1) {
            this.warningShow = true
            this.warningText1 = this.$t('lang.sctePgmStartNote')
            this.warningText2 = this.$t('lang.sctePgmEndNote')
          } else if (val.pgmStartScte == 1 && val.pgmEndScte != 1) {
            this.warningShow = true
            this.warningText1 = this.$t('lang.sctePgmStartNote')
            this.warningText2 = ''
          } else if (val.pgmStartScte != 1 && val.pgmEndScte == 1) {
            this.warningText1 = '',
            this.warningText2 = this.$t('lang.sctePgmEndNote')
            this.warningShow = true
          } else {
            this.warningText1 = ''
            this.warningText2 = ''
            this.warningShow = false
          }
        } else {
          this.warningShow = false
          this.warningText1 = ''
          this.warningText2 = ''
        }
      },
      deep: true,
      immediate: true
    },
    'data.eventSegments' () {
      this.EventScteStart()
    }
  },
  filters: {
  },
  created () {
    this.EventScteStart()
    // 获取今年的夏令时时间
    const DstTime = Outil.DisplayDstSwitchDates(new Date().getYear())
    this.DstTime = DstTime
  },
  methods: {
    // 根据状态显示
    pgmStartTipsText (data) {
      if (data.pgmStartScte == 1) {
        return this.$t('lang.sctePgmStartNote')
      } else {
        return ''
      }
    },
    pgmEndTipsText (data) {
      if (data.pgmEndScte == 1) {
        if (this.ScteData.enablePgmEndDetection) {
          return this.$t('lang.sctePgmEndNote2')
        }
        return this.$t('lang.sctePgmEndNote')
      } else {
        return ''
      }
    },
    EventScteStart () {
      let TimeBlack = false
      let sourceBlank = false
      if (!this.data.tpeerid) {
        sourceBlank = true
        this.mainSource = true
      } else {
        this.mainSource = false
      }
      let lastEvent
      this.data.eventSegments.forEach(item => {
        // 事件scte是否是开始 判断是否是scte类型
        if (item.segmentId == 2 || item.segmentId == 4 || item.segmentId == 11) {
          // 判断scte是否在开始一分钟之内
          this.IsScteStart = this.data.startTime > (item.timingIn - 60 * 1000)
        }
        if (item.segmentId == 4 || item.segmentId == 5 || item.segmentId == 10 || ((item.segmentId == 2 || item.segmentId == 11) && item.eventOperationType != 'Scte only')) {
          if (!item.sourceId) {
            sourceBlank = true
          }
        }
        if (item.segmentId != 13) {
          lastEvent = item
        }
      })
      if (lastEvent) {
        if (lastEvent.timingOut < this.data.endTime) {
          TimeBlack = true
        }
      }
      if (TimeBlack && sourceBlank) {
        this.sourceBlank = 3
      } else if (TimeBlack) {
        this.sourceBlank = 1
      } else if (sourceBlank) {
        this.sourceBlank = 2
      } else {
        this.sourceBlank = 0
      }
    },
    // 获取事件距离上面的长度
    getEventTop (time) {
      if (!time) return '0px'
      const seconds = new Date(time).getSeconds()
      return `${seconds / 10}px`
    },
    // 获取激活虚线的高度
    getActiveHeight () {
      const start = this.data.startTime
      let priorToEndTime = 25
      if (this.ScteData.priorToEndTime || this.ScteData.priorToEndTime == 0) {
        priorToEndTime = Number(this.ScteData.priorToEndTime)
      }
      const end = this.data.endTime - priorToEndTime * 60 * 1000
      return Math.floor((end - start) / 10000)
    },
    // 激活时间
    ActiveTime () {
      let priorToEndTime = 25
      let afterToEndTime = 2
      if (this.ScteData.priorToEndTime || this.ScteData.priorToEndTime == 0) {
        priorToEndTime = Number(this.ScteData.priorToEndTime)
      }
      if (this.ScteData.afterToEndTime || this.ScteData.afterToEndTime == 0) {
        afterToEndTime = Number(this.ScteData.afterToEndTime)
      }
      const startTime = this.transitionHourly(new Date(this.data.endTime - priorToEndTime * 60 * 1000))
      const endTime = this.transitionHourly(new Date(this.data.endTime + afterToEndTime * 60 * 1000))
      return `${startTime} - ${endTime}`
    },
    // 24小时制转12小时制
    transitionHourly (time) {
      if (time) {
        let type = ''
        let hour = time.getHours()
        let min = time.getMinutes()
        let s = time.getSeconds()
        const TimeFormat = Outil.getDateTimeFormat()
        if (TimeFormat.broadcastTimeFormat) {
          hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
        } else {
          if (hour >= 0 && hour <= 11) {
            type = 'AM'
            hour = hour == 0 ? 12 : hour
          } else {
            type = 'PM'
            hour = hour == 12 ? hour : hour - 12
          }
        }
        min = min >= 0 && min < 10 ? `0${min}` : min
        s = s >= 0 && s < 10 ? `0${s}` : s
        return `${hour}:${min}:${s} ${type}`
      }
    },
    // 计算样式
    computedStyle (item, parentItem) {
      const ScteTop = Math.floor(item.timingIn - parentItem.startTime) / 10000
      const ScteHeight = Math.floor(item.timingOut - item.timingIn) / 10000
      const style = {
        height: `${ScteHeight}px`,
        top: `${ScteTop}px`
      }
      if (parentItem.breakTime) {
        if (parentItem.breakTime >= item.timingOut) {
          style.height = '0px'
          style.display = 'none'
        } else if (
          parentItem.breakTime >= item.timingIn &&
          parentItem.breakTime <= item.timingOut
        ) {
          const ScteTop = 0
          const ScteHeight =
            (Math.floor(item.timingOut - parentItem.breakTime) / 10000)
          style.top = `${ScteTop}px`
          style.height = `${ScteHeight}px`
        } else {
          const ScteTop =
            (Math.floor(item.timingIn - parentItem.breakTime) / 10000)
          const ScteHeight =
            (Math.floor(item.timingOut - item.timingIn) / 10000)
          style.top = `${ScteTop}px`
          style.height = `${ScteHeight}px`
        }
      }
      if (item.segmentId == 5) {
        style['background-color'] = '#388BE5'
      } else if (item.segmentId == 10) {
        style['background-color'] = '#DA6F17'
      }
      return style
    },
    getBorderColor (color) {
      return this.colors[color]
    },
    // 获去事件高度
    getHeight () {
      let start =
        typeof this.data.startTime == 'object'
          ? this.data.startTime.getTime()
          : this.data.startTime
      if (this.data.breakTime) {
        start = this.data.breakTime
      }
      const end =
        typeof this.data.ShowEndTime == 'object'
          ? this.data.ShowEndTime.getTime()
          : this.data.ShowEndTime
      if (end < start) {
        return 0
      }
      let height = Math.floor((end - start) / 10000)
      if (this.DstTime.isDst) {
        const DstStart = this.DstTime.firstDstDate.startTime
        if (start < DstStart && end >= DstStart) {
          height = Math.floor((end - start + 60 * 60 * 1000) / 10000)
        }
      }
      return height
    },
    // 打开创建编辑框
    openEventFormBox (e) {
      // 打开创建编辑框
      this.$emit('popupCreateBox', {
        e,
        event: this.data,
        type: 0
      })
    },
    // 点击图标编辑
    ClickIconCompile (e) {
      // 打开创建编辑框
      this.$emit('popupCreateBox', {
        e,
        event: this.data,
        type: 1
      })
    }
  },
  beforeDestroy () {
    this.boxElement && this.boxElement.close()
  }
}
</script>
<style lang="less" scoped>
.event_item {
  min-height: 2px;
  // border: none;
  display: block;
  z-index: 1;
  position: absolute;
  width: calc(100% - 95px);
  left: 95px;
  box-sizing: border-box;
  // overflow: hidden;
  .IconWrap {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    padding-right: 3px;
    padding-top: 6px;
    p {
      width: 20px;
      height: 20px;
      background: #67aa25;
      text-align: center;
      line-height: 20px;
      margin-right: 2px;
      border-radius: 3px;
      i{
        font-size: 12px;
      }
      .icon-cc{
        font-size: 10px;
        transform: scale(0.7);
      }
      .icon-LG,.icon-CR,.icon-duplicate1 {
        transform: scale(0.8);
      }
    }
  }
  .ScteListWrap {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    .ScteWrap {
      width: 100%;
      background-color: #333;
      color: #fff;
      text-align: center;
      font-size: 12px;
      position: absolute;
      p {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      span {
        position: absolute;
        right: 10px;
        top: 0;
        i {
          color: #fff;
        }
      }
    }
    .ScteWrap::after {
      content: '';
      border-width: 5px 10px;
      border-style: solid;
      border-color: transparent rgba(255, 255, 255) transparent transparent;
      position: absolute;
      top: -5px;
      right: -10px;
    }
    .ScteWrap::before {
      content: '';
      border-width: 5px 10px;
      border-style: solid;
      border-color: transparent transparent transparent rgba(255, 255, 255);
      position: absolute;
      bottom: -5px;
      right: -20px;
    }
    .SerialNumber{
      width: 30px;
      // background: red;
      position: absolute;
      text-align: center;
      left: 22%;
    }
  }
  .event_detail {
    position: relative;
    padding: 0 20px 0 10px;
    z-index: 1001;
  }
  .event_detail > div {
    overflow: hidden;
    // padding-top: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .item_info {
      flex: 1;
      text-align: left;
      margin-right: 45px;
      .audioLevelDb{
        color: #252525;
        font-size: 10px;
        line-height: 1;
      }
    }
    .warning{
      margin-right: 5px;
      i{
        font-size: 12px;
        color: #EC5050
      }
      .grayWarning{
        color: #2c3e50;
      }
    }
  }
  .DetectionActiveLine {
    position: absolute;
    top: 10px;
    width: 100%;
    z-index: 1002;
    display: flex;
    justify-content: space-between;
    .dummyLineLeft{
      width: 10px;
      border-top: 2px dashed #EC5050;
    }
    .dummyLineRight{
      width: 277px;
      border-top: 2px dashed #EC5050;
    }
    .ActiveHint{
      position: absolute;
      left: 15px;
      top: -10px;
      padding: 0 5px;
      .warning{
        margin-right: 5px;
        i{
          font-size: 12px;
          color: #EC5050
        }
        .grayWarning{
          color: #2c3e50;
        }
      }
      .DetectionActive{
        font-size: 12px;
        color: #A93737;
      }
    }
  }
  .active_box {
    position: absolute;
    left: 0;
    top: -40px;
    height: 40px;
    width: 100%;
    display: none;
    > div {
      width: 100%;
      height: 32px;
      padding: 6px;
      border-radius: 4px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
    }
    .item_info {
      flex: 1;
      text-align: left;
      margin-right: 10px;
    }
    .warning{
      margin-right: 5px;
      i{
        font-size: 12px;
        color: #EC5050
      }
      .grayWarning{
        color: #2c3e50;
      }
    }
    .el-icon-caret-bottom {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -5px;
      font-size: 20px;
    }
  }
  .start_time {
    position: absolute;
    left: -80px;
    top: 50%;
    transform: translateY(-50%);
    color: #ccc;
    font-size: 12px;
  }
  span,
  i {
    color: #252525;
  }
}
.daylightSavingTime{
  border: 5px solid #068043;
}
.IsScteStart {
  span{
    color: #ffffff;
  }
}
.event_item:hover {
  .active_box {
    display: block;
  }
}
.startShow{
  border-top: 2px dashed #EC5050 !important;
}
.endShow{
  border-bottom: 2px dashed #EC5050 !important;
}
</style>
<style lang="less">
.el-popper[x-placement^='top'] .popper__arrow:after,
.el-popper[x-placement^='bottom'] .popper__arrow:after {
  border-top-color: #252525;
  border-bottom-color: #252525;
  bottom: 0;
  top: 0;
}
.playout_calendar_create_box {
  padding: 0 !important;
  background-color: transparent !important;
  min-height: 300px;
  max-height: 370px;
  border: none;
  border-radius: 4px;
  padding: 0.16rem 0.2rem;
  z-index: 2037 !important;
  color: #999;
  font-size: 0.16rem;
  box-sizing: border-box;
  box-shadow: none;
  .el-icon-circle-close:before {
    content: '\E60F';
    font-weight: 700;
    font-size: 18px;
  }
  .booking_create_close {
    font-size: 16px;
    color: #999;
  }
  .el-textarea__inner {
    background: #444;
    border: none;
    font-size: 12px;
  }
  .el-icon-circle-close:before {
    content: '\E78D';
    font-weight: 700;
    font-size: 18px;
  }
  .booking_create_close {
    font-size: 16px;
    color: #999;
  }
  .el-textarea__inner {
    background: #444;
    border: none;
    font-size: 12px;
  }
  .el-input .el-input__inner {
    background: #444;
    border: none;
    height: 30px;
    font-size: 12px;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .el-form-item__content {
    line-height: 30px;
  }
  .el-input .el-input__inner::placeholder {
    color: #bbb;
  }
}

.scteWarning{
  width: 500px;
}
</style>
